module.exports = __webpack_public_path__ + "img/12.c00b8b26.svg";